module.exports = __webpack_public_path__ + "img/tooltip_03-vallone-aure.991ae11e.jpg";